import qs from './qs';

export default selector => qs(selector) !== null;



/** WEBPACK FOOTER **
 ** ./app/scripts/util/dom/isElement.js
 **/